<template>
  <div class="svc">
    <!-- ===== 顶部 Banner（全宽背景） ===== -->
    <section class="hero">
      <div class="hero-inner">
        <div class="hero-left">
          <h1 class="hero-title">{{ page.heroTitle }}</h1>
          <p class="hero-desc">{{ page.heroDesc }}</p>

          <!-- <button class="hero-btn" type="button" @click="videoOpen = true"> -->
            <!-- 视频介绍
          </button> -->
        </div>

        <div class="hero-right" aria-hidden="true">
          <!-- 右侧插画：你后面换成你自己的图即可 -->
          <img style="width: 400px;height: 300px;border-radius: 18px;" mode="scaleToFill" src="../static/4.webp" />

        </div>
      </div>
    </section>

    <!-- ===== 内容块（灰白交替 / 左右交错） ===== -->
    <section v-for="(block, idx) in page.blocks" :key="block.key" class="block" :class="{ alt: idx % 2 === 1 }">
      <div class="container">
        <h2 class="block-title">{{ block.title }}</h2>
        <p v-if="block.sub" class="block-sub">{{ block.sub }}</p>

        <div class="block-body" :class="{ reverse: block.mediaSide === 'right' }">
          <!-- 媒体 -->
          <div class="media">
            <img v-if="block.img" class="media-img" :src="block.img" alt="" />
          </div>

          <!-- 文案 -->
          <div class="text">
            <ul class="bullets">
              <li v-for="(b, i) in block.bullets" :key="b">
                <span class="dot" :class="`dot-${i % 4}`" aria-hidden="true"></span>
                <span class="btxt">{{ b }}</span>
              </li>
            </ul>

            <div class="actions" v-if="block.actions?.length">
              <button v-for="(a, i) in block.actions" :key="a.label" class="act" :class="{ primary: i === 0 }"
                type="button" @click="onAction(a)">
                {{ a.label }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 视频弹窗（占位，你可换成 iframe/video） ===== -->
    <div v-if="videoOpen" class="modal" @click.self="videoOpen = false">
      <div class="modal-card">
        <div class="modal-hd">
          <div class="modal-title">视频介绍</div>
          <button class="modal-x" @click="videoOpen = false">×</button>
        </div>
        <div class="modal-bd">
          <div class="video-ph">视频填充处</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const videoOpen = ref(false);

/**
 * ✅ 关键：6 个卡片只需要传 query.key
 * /service?key=brand / trace / code / channel / marketing / insight
 */
const key = computed(() => String(route.query.key || "brand"));

/** 你后面把图片链接换成你自己的本地资源也行 */
const mockArt = require("../static/1.webp");
const mockImg1 = require("../static/2.webp");
const mockImg2 = require("../static/4.webp");
const mockImg3 = require("../static/6.webp");
const mockImg4 = require("../static/1.webp");
const mockImg5 = require("../static/6.webp");
const PAGE_MAP = {
  // 1) 品牌防伪平台（按你截图结构给满）
  // brand: {
  //   heroTitle: "品牌防伪",
  //   heroDesc:
  //     "优凡溯源科技——值得信赖的一物一码全链路数字化转型服务商。通过数字化防伪方案，助力品牌建立一站式防伪防窜解决方案。",
  //   heroArt: mockArt,
  //   blocks: [
  //     {
  //       key: "antiCounterfeit",
  //       title: "防伪服务",
  //       sub: "为品牌量身定制防伪与验证体系，数字技术管理让假货无处安身。",
  //       mediaSide: "left",
  //       img: mockImg1,
  //       bullets: [
  //         "提供定制化的防伪产品设计，满足品牌的多样化需求；",
  //         "自动化安全可靠的防伪编码体系，防伪数据更安全；",
  //         "防伪材质测试，包装应用验证，确保防伪产品品质；",
  //         "防伪页面定制化设计，营销引流，让数据赋能价值；",
  //         "多种查询方式，满足企业的要求，方便消费者查询；",
  //         "提供全套的防伪产品解决方案，全链路数字化保驾护航；",
  //       ],
  //       actions: [{ label: "立即咨询", type: "contact" }, { label: "了解详情", type: "detail" }],
  //     },
  //     {
  //       key: "mat",
  //       title: "防伪材料",
  //       sub: "专业防伪技术沉淀，提供高质量可溯源的防伪材料与应用方案。",
  //       mediaSide: "right",
  //       img: mockImg2,
  //       bullets: [
  //         "每个产品都有唯一数字身份码，实现产品的一码管理；",
  //         "严格的品质测试与应用验证，确保满足品牌需求；",
  //         "支持二维码、NFC/RFID 等多形态赋码与管理；",
  //         "实现防伪验证、溯源追踪、营销引流的一体化闭环；",
  //         "让防伪产品具备统一、稳定、安全、便捷的应用体验；",
  //       ],
  //       actions: [{ label: "立即咨询", type: "contact" }, { label: "了解详情", type: "detail" }],
  //     },
  //     {
  //       key: "online",
  //       title: "线上品牌保护",
  //       sub: "帮助品牌打击线上假货，快速建立品牌保护与维权的数字化能力。",
  //       mediaSide: "left",
  //       img: mockImg3,
  //       bullets: [
  //         "打造产品全生命周期的电子身份与可信数据；",
  //         "支持线上渠道验真，提升消费者信任；",
  //         "沉淀真实数据资产，支撑策略优化与增长分析；",
  //       ],
  //       actions: [{ label: "立即咨询", type: "contact" }, { label: "了解详情", type: "detail" }],
  //     },
  //     {
  //       key: "rights",
  //       title: "打假维权",
  //       sub: "联动稽查与取证能力，提升打假效率，维护品牌权益与消费者利益。",
  //       mediaSide: "right",
  //       img: mockImg4,
  //       bullets: [
  //         "异常扫码预警、数据取证与线索沉淀；",
  //         "稽查闭环管理：发现—核查—处置—复盘；",
  //         "快速定位风险区域与渠道，提升维权效率；",
  //       ],
  //       actions: [{ label: "立即咨询", type: "contact" }, { label: "了解详情", type: "detail" }],
  //     },
  //   ],
  // },

  // 2~6) 其余平台：先按同款布局给你“可直接用”的内容（你后面换文案即可）
  brand: {
    heroTitle: "经营信息",
    heroDesc:
      "家用电器、照明灯具、塑料制品、五金件的制造、加工；自营和代理货物和技术的进出口（国家限定经营或禁止进出口的除外）。",
    heroArt: "", // 你有证照/工厂图就换成图片链接；不填会显示“插画”占位
    blocks: [
      {
        key: "scope",
        title: "经营范围",
        sub: "主营业务范围（按证照文字整理）。",
        mediaSide: "left",
        img: mockImg5, // 这里可放“经营范围”那张截图
        mediaPlaceholder: "经营范围图片",
        bullets: [
          "家用电器的制造、加工；",
          "照明灯具的制造、加工；",
          "塑料制品的制造、加工；",
          "五金件的制造、加工；",
        ],
        // actions: [{ label: "立即咨询", type: "contact" }, { label: "了解详情", type: "detail" }],
      },
      {
        key: "address",
        title: "住所（注册地址）",
        sub: "企业登记住所信息。",
        mediaSide: "right",
        img: "", // 这里可放“住所/地址”那张截图
        mediaPlaceholder: "住所信息图片",
        bullets: ["余姚市凤山街道永丰村冯严34号。"],
        // actions: [{ label: "立即咨询", type: "contact" }, { label: "了解详情", type: "detail" }],
      },
      {
        key: "importExport",
        title: "进出口业务",
        sub: "自营/代理进出口范围说明。",
        mediaSide: "left",
        img: mockImg3,
        mediaPlaceholder: "进出口说明图片",
        bullets: [
          "自营和代理货物和技术的进出口；",
          "国家限定经营或禁止进出口的货物和技术除外。",
        ],
        // actions: [{ label: "立即咨询", type: "contact" }, { label: "了解详情", type: "detail" }],
      },
      {
        key: "compliance",
        title: "合规与审批",
        sub: "依法审批项目的经营要求。",
        mediaSide: "right",
        img: mockImg4, // 这里可放“依法须经批准…”那段截图
        mediaPlaceholder: "合规说明图片",
        bullets: ["依法须经批准的项目，经相关部门批准后方可开展经营活动。"],
        // actions: [{ label: "立即咨询", type: "contact" }, { label: "了解详情", type: "detail" }],
      },
    ],
  },

  trace: {
    heroTitle: "智能激光视觉定位灯（进阶款）",
    heroDesc: "在激光定位基础上融合视觉校准技术，实现复杂场景下的高精度、可联动定位，适配中高端工业智能化需求。",
    heroArt: mockArt,
    blocks: [
      {
        key: "t1",
        title: "激光 + 视觉双重定位",
        sub: "突破单一方式精度局限，复杂场景依然稳定可靠。",
        mediaSide: "left",
        img: mockImg1,
        bullets: ["激光粗定位 + 视觉精校准", "复杂光照环境自适应", "多工位统一标准定位"],
      },
      {
        key: "t2",
        title: "智能联动",
        sub: "适配工业自动化升级需求，可对接产线系统。",
        mediaSide: "right",
        img: mockImg2,
        bullets: ["支持与产线 PLC / 传感器联动", "定位参数可配置", "异常状态实时提示"],
      },
    ],
  },

  code: {
    heroTitle: "防爆型耐高温定位灯（特种款）",
    heroDesc: "面向极端环境专属设计，具备防爆、耐高温、抗强震特性，保障特殊场景作业安全。",
    heroArt: mockArt,
    blocks: [
      {
        key: "c1",
        title: "防爆安全设计",
        sub: "符合防爆环境使用要求，为危化、油气等场景提供可靠的照明与定位。",
        mediaSide: "left",
        img: mockImg1,
        bullets: ["防爆结构设计", "高等级密封防护", "适用于易燃易爆场所"],
      },
      {
        key: "c2",
        title: "耐高温抗强震",
        sub: "高温、强震环境下依然稳定工作，长期可靠。",
        mediaSide: "right",
        img: mockImg2,
        bullets: ["耐高温材料与散热设计", "抗强震结构", "支持长时间连续工作"],
      },
    ],
  },

  channel: {
    heroTitle: "定制化定位灯（专属款）",
    heroDesc: "针对特殊行业、特殊设备的个性化定位需求，提供定制化研发与生产服务。",
    heroArt: mockArt,
    blocks: [
      {
        key: "ch1",
        title: "按需定制",
        sub: "图形、颜色、尺寸、安装方式均可按实际场景定制。",
        mediaSide: "left",
        img: mockImg1,
        bullets: ["自定义投射图形", "多规格可选", "灵活安装适配"],
      },
      {
        key: "ch2",
        title: "研发生产一体",
        sub: "从需求评估到打样量产，一站式完成定制交付。",
        mediaSide: "right",
        img: mockImg2,
        bullets: ["需求评估与方案设计", "打样验证快速响应", "小批量试产到规模量产"],
      },
    ],
  },

  marketing: {
    heroTitle: "双重定位技术",
    heroDesc: "采用“激光定位 + 视觉校准”双重核心技术，突破传统单一定位方式的精度局限。",
    heroArt: mockArt,
    blocks: [
      {
        key: "m1",
        title: "激光定位",
        sub: "毫米级基准投射，提供稳定清晰的定位基准。",
        mediaSide: "left",
        img: mockImg1,
        bullets: ["毫米级定位精度", "投射清晰稳定", "多种图形可选"],
      },
      {
        key: "m2",
        title: "视觉校准",
        sub: "视觉反馈自动校准，复杂环境依然精准。",
        mediaSide: "right",
        img: mockImg2,
        bullets: ["自动校准补偿", "复杂光照自适应", "定位精度再升级"],
      },
    ],
  },

  insight: {
    heroTitle: "耐用性设计",
    heroDesc: "外壳采用高强度铝合金材质，经过阳极氧化处理，耐腐蚀、抗冲击，适应严苛工业环境长期使用。",
    heroArt: mockArt,
    blocks: [
      {
        key: "i1",
        title: "高强度结构",
        sub: "铝合金机身与加固设计，抗冲击、耐磨损。",
        mediaSide: "left",
        img: mockImg1,
        bullets: ["高强度铝合金外壳", "阳极氧化表面处理", "耐腐蚀、抗冲击"],
      },
      {
        key: "i2",
        title: "工业级防护",
        sub: "适应振动、粉尘、油污等复杂工业环境。",
        mediaSide: "right",
        img: mockImg2,
        bullets: ["防尘耐污设计", "宽温域工作范围", "长寿命光源配置"],
      },
    ],
  },
};

const page = computed(() => PAGE_MAP[key.value] || PAGE_MAP.brand);
function onAction(action) {
  // 这里你按需改：跳转到表单页、弹窗、或路由等
  if (action.type === "contact") {
    // 示例：跳到某个咨询页
    // router.push({ name: "contact" });
    alert("这里接入你的咨询逻辑");
    return;
  }
  if (action.type === "detail") {
    alert("这里接入你的详情逻辑");
    return;
  }
}
</script>

<style scoped>
/* ===== 页面容器 ===== */
.svc {
  background: #fff;
}

/* ===== 顶部 Hero（全宽） ===== */
.hero {
  position: relative;
  background: linear-gradient(90deg, #2b78e4 0%, #13b6c6 100%);
  overflow: hidden;
}

.hero::after {
  content: "";
  position: absolute;
  inset: 0;
  opacity: 0.25;
  background-image: radial-gradient(circle at 15% 30%, rgba(255, 255, 255, 0.35), transparent 45%),
    radial-gradient(circle at 70% 60%, rgba(255, 255, 255, 0.25), transparent 50%);
  pointer-events: none;
}

.hero-inner {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
  padding: 44px 18px;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 22px;
  align-items: center;
}

.hero-title {
  margin: 0;
  color: #fff;
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.5px;
}

.hero-desc {
  margin: 12px 0 0;
  color: rgba(255, 255, 255, 0.9);
  font-size: 13px;
  line-height: 1.9;
  max-width: 520px;
}

.hero-btn {
  margin-top: 18px;
  height: 34px;
  padding: 0 16px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  cursor: pointer;
}

.hero-btn:hover {
  background: rgba(255, 255, 255, 0.18);
}

.hero-right {
  position: relative;
  display: flex;
  justify-content: flex-end;
}

.hero-art {
  width: 360px;
  height: 180px;
  object-fit: cover;
  border-radius: 14px;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
}

.hero-art-ph {
  width: 360px;
  height: 180px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.9);
}

.hero-play {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(40%, -50%);
  width: 54px;
  height: 54px;
  border-radius: 999px;
  border: 2px solid rgba(255, 255, 255, 0.75);
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  cursor: pointer;
}

.hero-play:hover {
  background: rgba(255, 255, 255, 0.25);
}

/* ===== 内容块（灰白交替） ===== */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 18px;
}

.block {
  padding: 56px 0;
  background: #fff;
}

.block.alt {
  background: #f5f7fb;
}

.block-title {
  margin: 0;
  text-align: center;
  font-size: 20px;
  font-weight: 800;
  color: #333;
}

.block-sub {
  margin: 12px auto 0;
  text-align: center;
  color: #8a8a8a;
  font-size: 12px;
  line-height: 1.9;
  max-width: 860px;
}

.block-body {
  margin-top: 28px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.block-body.reverse {
  grid-template-columns: 1.1fr 1fr;
}

.block-body.reverse .media {
  order: 2;
}

.block-body.reverse .text {
  order: 1;
}

/* 媒体区 */
.media {
  display: flex;
  justify-content: center;
}

.media-img {
  width: 520px;
  max-width: 100%;
  height: 230px;
  object-fit: cover;
  border-radius: 12px;
}

.media-ph {
  width: 520px;
  max-width: 100%;
  height: 230px;
  border-radius: 12px;
  background: #eef2f8;
  border: 1px solid #e6ecf6;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8b96a8;
}

/* 文案区 */
.text {
  min-width: 0;
}

.bullets {
  list-style: none;
  padding: 0;
  margin: 0;
}

.bullets li {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  padding: 8px 0;
  color: #4a4a4a;
  font-size: 13px;
  line-height: 1.9;
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 99px;
  margin-top: 8px;
  flex: 0 0 auto;
}

.dot-0 {
  background: #1f6bd6;
}

.dot-1 {
  background: #2bb5c8;
}

.dot-2 {
  background: #7cc35c;
}

.dot-3 {
  background: #f0b429;
}

.actions {
  margin-top: 16px;
  display: flex;
  gap: 12px;
}

.act {
  height: 34px;
  padding: 0 16px;
  border-radius: 6px;
  border: 1px solid #cfd9ea;
  background: #fff;
  color: #1f2d3d;
  cursor: pointer;
}

.act.primary {
  border-color: #0a4f97;
  background: #0a4f97;
  color: #fff;
}

.act:hover {
  filter: brightness(0.98);
}

/* ===== Modal ===== */
.modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

.modal-card {
  width: min(860px, calc(100vw - 36px));
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
}

.modal-hd {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid #eee;
}

.modal-title {
  font-weight: 800;
  color: #222;
}

.modal-x {
  border: none;
  background: transparent;
  font-size: 22px;
  cursor: pointer;
  color: #666;
}

.modal-bd {
  padding: 16px;
}

.video-ph {
  height: 420px;
  background: #f3f6fb;
  border: 1px dashed #cdd6e6;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7a879b;
}

/* 响应式 */
@media (max-width: 980px) {
  .hero-inner {
    grid-template-columns: 1fr;
  }

  .hero-right {
    justify-content: flex-start;
  }

  .hero-play {
    transform: translate(-50%, -50%);
    left: 50%;
  }

  .block-body,
  .block-body.reverse {
    grid-template-columns: 1fr;
  }

  .block-body.reverse .media,
  .block-body.reverse .text {
    order: initial;
  }
}
</style>
